import {
  Cancel,
  CheckCircle,
  Info,
  Person,
  Schedule,
} from '@mui/icons-material';

export const DECISION_NODES = {
  APPROVED: { name: 'Aprobada', id: -1 },
  REJECTED: { name: 'Rechazada', id: -2 },
};

export const CURRENCIES = [
  { value: 'CLP', label: 'CLP' },
  { value: 'USD', label: 'USD' },
  { value: 'UF', label: 'UF' },
];

export const SGR_TYPES = [
  { value: 'offer-seriousness', label: 'Seriedad de la Oferta' },
  { value: 'faithful-compliance', label: 'Fiel Cumplimiento' },
  { value: 'advance', label: 'Anticipo' },
  { value: 'proper-performance', label: 'Correcta ejecución' },
  {
    value: 'faithful-compliance-performance',
    label: 'Fiel cumplimiento y correcta ejecución',
  },
];

export const SGR_STATES = [
  { value: 'LEAD', label: 'Lead', color: 'purple', icon: Person },
  { value: 'QUOTED', label: 'Cotizada', color: 'default', icon: Schedule },
  { value: 'IN_REVIEW', label: 'En Revisión', color: 'warning', icon: Info },
  { value: 'APPROVED', label: 'Aprobada', color: 'info', icon: CheckCircle },
  { value: 'ACTIVE', label: 'Activa', color: 'success', icon: CheckCircle },
  { value: 'REJECTED', label: 'Rechazada', color: 'error', icon: Cancel },
  { value: 'INACTIVE', label: 'Caducada', color: 'error', icon: Cancel },
  { value: 'CLAIMED', label: 'Siniestrada', color: 'error', icon: Cancel },
  { value: 'CANCELLED', label: 'Cancelada', color: 'error', icon: Cancel },
  { value: 'LOST', label: 'Perdida', color: 'error', icon: Cancel },
] as const;

export const SGR_STATES_FILTERS = [
  {
    value: 'oportunity',
    label: 'Oportunidades',
    states: ['QUOTED', 'LEAD'],
  },
  {
    value: 'process',
    label: 'En Proceso',
    states: ['IN_REVIEW', 'APPROVED', 'REJECTED'],
  },
  { value: 'active', label: 'Vigentes', states: ['ACTIVE'] },
  { value: 'expired', label: 'Caducadas', states: ['INACTIVE'] },
  { value: 'claimed', label: 'Siniestrados', states: ['CLAIMED'] },
  { value: 'cancelled', label: 'Anulados', states: ['CANCELLED'] },
  { value: 'lost', label: 'Perdida', states: ['LOST'] },
] as const;

export type SGRStateFilter = (typeof SGR_STATES_FILTERS)[number]['value'];

export const QUOTED_STATES = [
  'QUOTED',
  'REQUESTED',
  'IN_REVIEW',
  'REVIEWED',
  'APPROVED',
  'REJECTED',
];
export const ACTIVE_STATES = ['ACTIVE'];
export const EXPIRED_STATES = ['INACTIVE'];
export const CLAIMED_STATES = ['CLAIMED'];
export const CANCELLED_STATES = ['CANCELLED'];

export const SGR_STATUS_GROUPS = [
  { value: 'quoted', label: 'Cotizadas' },
  { value: 'active', label: 'Activas' },
  { value: 'expired', label: 'Caducadas' },
  { value: 'claimed', label: 'Siniestrados' },
  { value: 'cancelled', label: 'Anuladas' },
];

export const SGR_DEFAULT_RATES = {
  fixedRate: 0.5,
  variableRate: 4.5,
  fixedDiscount: 0,
  variableDiscount: 0,
};

export const SGR_LOST_REASONS = [
  { value: 'EXPIRED', label: 'Expirada' },
  { value: 'PRICE', label: 'Precio' },
  { value: 'WITHDRAWN', label: 'Retirada' },
  { value: 'OTHER', label: 'Otro' },
];

export const PRODUCT_TYPES = [
  { value: 'factoring', label: 'Factoring' },
  { value: 'credit', label: 'Crédito' },
  { value: 'invoice', label: 'Factura' },
  { value: 'confirming', label: 'Confirming' },
  { value: 'sgr', label: 'SGR' },
];

export const CREDIT_LINE_STATES = [
  { value: 'NOT_REQUESTED', label: 'No solicitada' },
  { value: 'VALIDATING', label: 'Validando' },
  { value: 'REVIEWED', label: 'Revisada' },
  { value: 'ASSIGNED', label: 'Asignada' },
  { value: 'ACTIVE', label: 'Activa' },
  { value: 'REJECTED', label: 'Rechazada' },
  { value: 'FROZEN', label: 'Congelada' },
  { value: 'DUE', label: 'Vencida' },
];

export const TENDER_STATES = [
  { value: 5, label: 'Publicada', color: 'success', icon: CheckCircle },
  { value: 6, label: 'Cerrada', color: 'error', icon: Cancel },
  { value: 7, label: 'Desierta', color: 'error', icon: Cancel },
  { value: 8, label: 'Adjudicada', color: 'success', icon: CheckCircle },
  { value: 15, label: 'Revocada', color: 'error', icon: Cancel },
  { value: 16, label: 'Suspendida', color: 'error', icon: Cancel },
];

export const PURCHASE_ORDER_STATES = [
  { value: 4, label: 'Enviada a Proveedor', color: 'warning', icon: Info },
  { value: 5, label: 'En proceso', color: 'success', icon: CheckCircle },
  { value: 6, label: 'Aceptada', color: 'success', icon: CheckCircle },
  { value: 9, label: 'Cancelada', color: 'error', icon: Cancel },
  {
    value: 12,
    label: 'Recepción Conforme',
    color: 'success',
    icon: CheckCircle,
  },
  {
    value: 13,
    label: 'Pendiente de Recepcionar',
    color: 'warning',
    icon: Info,
  },
  {
    value: 14,
    label: 'Recepcionada Parcialmente',
    color: 'warning',
    icon: Info,
  },
  {
    value: 15,
    label: 'Recepcion Conforme Incompleta',
    color: 'error',
    icon: Cancel,
  },
];

export type ProductType = (typeof PRODUCT_TYPES)[number]['value'];

export const PAYMENT_REQUEST_PASSIVE_STATES: Record<string, string> = {
  IN_REVIEW: 'En revisión',
  IN_TRANSFER: 'En giro',
  COMPLETED: 'Completada',
  REJECTED: 'Rechazada',
};

export const MONTH_NAMES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const RESSELL_CONCILIATION_TYPES_DESCRIPTIONS = {
  fundPayment: 'El deudor pago al fondo por la venta.',
  paidPendingAccountDocument:
    'Se hizo una recaudación propia del documento vendido al fondo. Por ende, se generó una CxP para devolver al fondo. Esta ya fue pagada.',
  resellNomineeApplication:
    'El documento vendido se aplicó/pagó en otra operación con el fondo.',
  buyback:
    'El documento vendido se recompró al fondo. Por lo que este mmonto se saldó con el fondo.',
};

export const SGR_WARRANTY_DEFAULT_COSTS: Record<
  string,
  { operationCostVariable: number; operationCostFixed: number }
> = {
  'Seriedad de oferta': { operationCostVariable: 5, operationCostFixed: 0.5 },
  'Fiel cumplimiento': { operationCostVariable: 4.5, operationCostFixed: 0.5 },
  'Correcta ejecucion': { operationCostVariable: 5, operationCostFixed: 0.5 },
  Anticipo: { operationCostVariable: 8, operationCostFixed: 0.5 },
};
